export const tags = state => state.tags;

export const tag = state => state.tag;

export const lang = state => state.lang;

export const downloads = state => state.downloads;
